'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminReducers = undefined;

var _AdminApp = require('./AdminApp');

var _AdminApp2 = _interopRequireDefault(_AdminApp);

var _reducers = require('./reducers');

var adminReducers = _interopRequireWildcard(_reducers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by sidchik on 03.04.17.
 */
exports.adminReducers = adminReducers;
exports.default = _AdminApp2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/index.js
// module id = 1285
// module chunks = 5